export default __webpack_public_path__ + "static/media/location.b7935b6c.svg";